import script from "./AreaSelectorMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./AreaSelectorMenu.vue?vue&type=script&setup=true&lang=ts"

import "./AreaSelectorMenu.vue?vue&type=style&index=0&id=0e4b4168&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e4b4168"]])

export default __exports__